if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      // Elements
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.shippingMessage = this.querySelector('.js-shipping-message');

      // Data
      this.variantInventory = this.getVariantInventory();
      this.freeShipThreshold = parseInt(this.dataset.freeShipThreshold || '9900', 10); // $99 default
      this.hideFreeShip = (this.dataset.hideFreeShip ?? '')
          .toString()
          .trim()
          .toLowerCase() === 'true';
      this.currentPriceCents = parseInt(this.dataset.initialPrice || '0', 10);

      // Bind to on:variant:change for this product
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Initial render
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity || '0', 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy,
        this.currentPriceCents
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.closest('.product-info').querySelector('.js-inventory-data');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const v = evt.detail.variant;
        const inventory = this.variantInventory.filter((variant) => variant.id === v.id)[0];

        // keep latest price (cents)
        this.currentPriceCents = typeof v.price === 'number' ? v.price : this.currentPriceCents;

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy,
          this.currentPriceCents
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     * @param {number} [priceCents] - optional price in cents for current variant
     */
    updateInventory(count, available, inventoryPolicy, priceCents = this.currentPriceCents) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }
  // If we're on the product page and it's a preorder/backorder, hide the whole block
  const onPdp = !!this.closest('.product-info');
  const hideBackorderOnPdp = onPdp && inventoryLevel === 'backordered';

  if (hideBackorderOnPdp) {
    this.hidden = true;
    if (this.inventoryNotice) this.inventoryNotice.textContent = '';
    this.removeAttribute('data-inventory-level');
    this.shippingMessage?.classList.remove('show');
    return; // stop here — nothing else to render
  }
      // Set the shipping message (unchanged)
      if (available === false) {
  this.shippingMessage?.classList.remove('show');
} else {
  const cutoffHour = 15;
  const now = new Date();
  const day = now.getDay(); // 0=Sun..6=Sat
  const hour = now.getHours();
  let message = null; // use null to mean "hide completely"

  if (day >= 0 && day <= 4) {
    message = hour < cutoffHour
      ? ' - Order by 3pm for overnight delivery!'
      : ' - Ships tomorrow from our NZ warehouse!';
  } else if (day === 5) {
    message = hour < cutoffHour
      ? ' - Order by 3pm for same-day dispatch!'
      : null; // Friday after cutoff → hide
  } else if (day === 0) {
    message = ' - Ships Monday from our NZ warehouse!'; // Sunday
  } else if (day === 6) {
    message = null; // Saturday → hide
  }

  if (message) {
    this.shippingMessage.textContent = message;
    this.shippingMessage.classList.add('show');
  } else {
    this.shippingMessage.textContent = ''; // clear leftover text
    this.shippingMessage.classList.remove('show');
  }
}


      // Decide whether to show the inventory block
        if (
           this.dataset.showNotice === 'always' ||
           (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')) ||
            inventoryLevel === 'backordered'  // allow the pill on backorders too
            ) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

// ----- Base pill text (stock state) -----
if (inventoryLevel === 'backordered') {
  const raw = this.dataset.textNoStockBackordered || 'Pre-order';
  const clean = raw
    .replace(/<[^>]*>/g, '')    // strip HTML tags
    .replace(/^\s*[-–—]\s*/, '') // drop a leading dash and spaces
    .trim();
  this.inventoryNotice.innerText = clean;
} else if (
  inventoryLevel !== 'in_stock' &&
  (this.dataset.showCount === 'always' ||
    (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))
) {
  this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
} else if (inventoryLevel === 'very_low') {
  this.inventoryNotice.innerText = theme.strings.veryLowStock;
} else if (inventoryLevel === 'low') {
  this.inventoryNotice.innerText = theme.strings.lowStock;
} else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
  this.inventoryNotice.innerText = theme.strings.inStock;
} else if (inventoryLevel === 'none') {
  this.inventoryNotice.innerText = theme.strings.noStock;
}


        // ----- FREE SHIPPING pill override (does not touch shippingMessage) -----
        const threshold = this.freeShipThreshold;
        const hideFreeShip = this.hideFreeShip;
        const inStockish = ['normal', 'in_stock', 'low', 'very_low'];

        const canShowFreeShip =
          !hideFreeShip &&
          available === true &&
          inStockish.includes(inventoryLevel) &&
          typeof priceCents === 'number' &&
          priceCents >= threshold;

        if (this.inventoryNotice) {
          if (canShowFreeShip) {
            this.inventoryNotice.innerText = '🚚 FREE SHIPPING';
            this.inventoryNotice.classList.add('pill--free-ship');
            this.setAttribute('data-free-shipping-pill', 'true');
          } else {
            this.inventoryNotice.classList.remove('pill--free-ship');
            this.removeAttribute('data-free-shipping-pill');
            // (Text already set above based on stock level)
          }
        }

        // ----- Urgency message (unchanged) -----
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
